module.exports = __webpack_public_path__ + "static/media/6.Tower-Crane.9a43ad7c.webp";